// Libs
import { API_COMMON_BASE_URL } from "../../utils/api.constants";
import axios, { AxiosResponse } from "axios";
// App
import { AUTHENTICATE_URL } from "./auth.constants";
import { SignInParam } from "./auth.interfaces";

/**
 * Authenticates user
 * @param param the authentication parameter
 */
export const authenticate = (param: SignInParam): Promise<AxiosResponse> => {
  return axios.post(`${API_COMMON_BASE_URL}/${AUTHENTICATE_URL}`, param);
};
